import { useContext } from "react";
import PropTypes from "prop-types";
import actions from "../actions";
import { UpdateFromPipelineContext } from "./UpdateFromPipelineContext";

import { WithShowPicker as OptionsStatusCell } from "./shared/OptionsStatusCell/OptionsStatusCell";

const TDIOptionsStatusCell = ({ listing }) => {
  const { state, dispatch } = useContext(UpdateFromPipelineContext);
  const isLoading = !!state.statusLoadingUuids?.[listing.uuid];

  const onChangeHandlr = async (_status) => {
    if (_status === listing.status) return;

    dispatch(actions.listings.setStatusLoading(listing.uuid, true));
    const copyListing = JSON.parse(JSON.stringify(listing));
    dispatch(actions.listings.updateListing(listing, _status));
    dispatch(actions.listings.updateStatusRequest(copyListing, { status: _status }));
  };

  return (
    <OptionsStatusCell
      transactionType={listing.type}
      status={listing.status}
      selectedStatus={onChangeHandlr}
      uuid={listing.uuid}
      isLoading={isLoading}
    />
  );
};

TDIOptionsStatusCell.propTypes = {
  listing: PropTypes.shape({
    address: PropTypes.shape({ streetAddress: PropTypes.string }),
    status: PropTypes.string,
    type: PropTypes.string,
    uuid: PropTypes.string,
  }),
};

TDIOptionsStatusCell.defaultProps = {
  listing: null,
};
export default TDIOptionsStatusCell;
